import React from 'react';
import PropTypes from 'prop-types';
import { FormattedTag } from 'core/components';
import { withLocale } from 'core/hocs';
import { isEmptyOrNil } from 'core/helpers';
import { PAYMENT_ITEM_KEYS } from 'core/constants';
import classNames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';
import { ALL_METHODS_KEY } from 'helpers/payment-method-grouping';
import { PaymentMethod } from './payment-method';

import './payment-method-list.scss';

const {
  PAYMENT_METHOD,
  MINIMUM_WITHDRAWAL,
  MINIMUM_DEPOSIT,
  MAXIMUM_WITHDRAWAL,
  MAXIMUM_DEPOSIT,
} = PAYMENT_ITEM_KEYS;

export const PaymentsMethodListUI = ({
  locale,
  otherItems,
  recentlyItems,
  handleSelectedCard,
  currency,
  isWithdrawal,
  activePaymentMethod,
  className,
  isModal,
  group,
  groupMap,
  selectGroup,
  intl,
}) => {
  const getCombinedItems = () => {
    let other = [];
    let recently = [];

    if (!isEmptyOrNil(otherItems)) {
      other = otherItems;
    }

    if (!isEmptyOrNil(recentlyItems)) {
      recently = recentlyItems;
    }

    return other.concat(recently.slice(2));
  };

  const combinedItems = getCombinedItems({
    otherItems,
    recentlyItems
  });

  const getGroupTitle = (key) => {
    if (key === ALL_METHODS_KEY) {
      return intl.formatMessage({ id: 'payment-method-grouping.all-methods' });
    }

    return key;
  };

  return (
    <div className={classNames('payment-list flex-column py-2_5 pl-2 pr-1', className)}>
      <FormattedTag id="profile-wallet.chose-payment-method" className="h4 font-weight-semi-bold mb-2" />

      {!isEmptyOrNil(groupMap) && Object.keys(groupMap).length > 1 && (
        <div className="payments-menu-group-grid p-0_5 mb-2_5">
          {Object.keys(groupMap).map(key => (
            <div
              key={key}
              tabIndex="0"
              role="button"
              onClick={selectGroup}
              onKeyPress={selectGroup}
              data-group={key}
              className={classNames('payments-menu-group-grid-item font-weight-semi-bold w-100',
                'd-flex flex-grow-1 justify-content-center text-nowrap py-1 px-1_5',
                {
                  'text-gray-0 bg-primary': key === group,
                  'text-gray-20': key !== group,
                })}
            >
              {getGroupTitle(key)}
            </div>
          ))}
        </div>
      )}

      <div className="d-flex payment-list-wrapper flex-column">
        {!isEmptyOrNil(recentlyItems) && (
          <>
            <FormattedTag id="profile-wallet.withdrawal.recently-used" className="text-base font-weight-semi-bold mb-2" />

            <div className="mb-2 rounded payment-list-methods payment-list-borders">
              {recentlyItems.map(method => (
                <PaymentMethod
                  locale={locale}
                  currency={currency}
                  onClick={handleSelectedCard}
                  paymentMethod={method[PAYMENT_METHOD]}
                  minimum={method[isWithdrawal ? MINIMUM_WITHDRAWAL : MINIMUM_DEPOSIT]}
                  maximum={method[isWithdrawal ? MAXIMUM_WITHDRAWAL : MAXIMUM_DEPOSIT]}
                  isWithdrawal={isWithdrawal}
                  key={method[PAYMENT_METHOD]}
                  activePaymentMethod={activePaymentMethod}
                  isModal={isModal}
                />
              ))}
            </div>
          </>
        )}
        {!isEmptyOrNil(otherItems) && (
          <>
            {!isEmptyOrNil(recentlyItems) && !isWithdrawal && (
              <FormattedTag
                id="profile-wallet.withdrawal.other-methods"
                className="text-base font-weight-semi-bold mb-2"
              />
            )}

            <div className="d-flex flex-column payment-list-borders">
              {combinedItems.map(method => (
                <PaymentMethod
                  isWithdrawal={isWithdrawal}
                  locale={locale}
                  key={method[PAYMENT_METHOD]}
                  paymentMethod={method[PAYMENT_METHOD]}
                  currency={currency}
                  onClick={handleSelectedCard}
                  minimum={method[isWithdrawal ? MINIMUM_WITHDRAWAL : MINIMUM_DEPOSIT]}
                  maximum={method[isWithdrawal ? MAXIMUM_WITHDRAWAL : MAXIMUM_DEPOSIT]}
                  disabled={isWithdrawal}
                  activePaymentMethod={activePaymentMethod}
                  isModal={isModal}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

PaymentsMethodListUI.propTypes = {
  locale: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  otherItems: PropTypes.arrayOf(
    PropTypes.shape({}),
  ),
  recentlyItems: PropTypes.arrayOf(
    PropTypes.shape({}),
  ),
  isWithdrawal: PropTypes.bool,
  handleSelectedCard: PropTypes.func.isRequired,
  activePaymentMethod: PropTypes.string,
  className: PropTypes.string,
  // toggleDepositNew: PropTypes.func,
  isModal: PropTypes.bool,
  group: PropTypes.string.isRequired,
  groupMap: PropTypes.shape({}).isRequired,
  selectGroup: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  // step: PropTypes.number,
  // isTabs: PropTypes.bool,
  // activeBonuses: PropTypes.arrayOf(PropTypes.shape()),
  // setActiveWithdrawalMethod: PropTypes.func,
  // pendingWithdrawalItemsLength: PropTypes.number.isRequired,
};

PaymentsMethodListUI.defaultProps = {
  // isTabs: false,
  isWithdrawal: false,
  recentlyItems: [],
  otherItems: [],
  activePaymentMethod: null,
  isModal: false,
  // step: null,
  // activeBonuses: {},
  className: '',
};

export const PaymentsMethodList = withLocale(injectIntl(PaymentsMethodListUI));
